import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createTasklistTemplate = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation createTasklistTemplate($caseTypeId: Int!, $name: String!, $position: Int!) {
            createTasklistTemplate(caseTypeId: $caseTypeId, name: $name, position: $position) { id createdAt message error }
          }
        `),
      variables: { caseTypeId: data.caseTypeId, name: data.name, position: data.position }
    })
  return response.data.createTasklistTemplate
}

export const updateTasklistTemplate = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation updateTasklistTemplate($id: Int!, $name: String!, $position: Int!) {
            updateTasklistTemplate(id: $id, name: $name, position: $position ) { message error }
          }
        `),
      variables: { id: data.id, name: data.name, position: data.position }
    })
  return response.data.updateTasklistTemplate
}

export const deleteTasklistTemplate = async (tasklistId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation deleteTasklistTemplate($id: Int!) {
            deleteTasklistTemplate(id: $id) { message error }
          }
        `),
      variables: { id: tasklistId }
    })
  return response.data.deleteTasklistTemplate
}
